import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'  // تغییر 1
import './Navbar.css'
import Login from '../Login/Login'
import Logo from './Reading glasses-cuate.svg';
import toast from 'react-hot-toast';
import axios from 'axios';

function Navbar() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [regUser, setRegUser] = useState(null);
    const [subscriptionInfo, setSubscriptionInfo] = useState(null);
    const [remainingDays, setRemainingDays] = useState(null);
    const [savedWordsCount, setSavedWordsCount] = useState(0);
    const user = localStorage.getItem('currentUser');
    const location = useLocation();  // تغییر 2

    // دریافت اطلاعات اشتراک از سرور
    const fetchSubscriptionInfo = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/check-subscription/${userId}`);
            if (response.data.success) {
                setSubscriptionInfo(response.data.subscription);
                
                if (response.data.subscription && response.data.subscription.isActive && response.data.subscription.endDate) {
                    const endDate = new Date(response.data.subscription.endDate);
                    const today = new Date();
                    const diffTime = endDate - today;
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    setRemainingDays(diffDays > 0 ? diffDays : 0);
                } else {
                    setRemainingDays(null);
                }
            }
        } catch (error) {
            console.error("Error fetching subscription:", error);
        }
    };

    const fetchSavedWordsCount = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/saved-words/${userId}`);
            setSavedWordsCount(response.data.data.length);
        } catch (error) {
            console.error("Error fetching saved words count:", error);
        }
    };

    const authUser = () => {
        if (!user) {
            toast.error("Please Login First")
            setTimeout(() => {
                toast.dismiss()
                window.location.href = '/signup'
            }, 1000);
        } else {
            window.location.href = '/books'
        }
    }
    
    useEffect(() => {
        const currentUser = localStorage.getItem('currentUser');
        if (currentUser) {
            try {
                const user = JSON.parse(currentUser);
                setIsLoggedIn(true);
                setRegUser(user);
                fetchSubscriptionInfo(user._id);
                fetchSavedWordsCount(user._id);
            } catch (e) {
                console.error("Error parsing user:", e);
            }
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('currentUser');
        toast.success("Logout successfully")
        setIsLoggedIn(false);
        setSubscriptionInfo(null);
        setRemainingDays(null);
        setSavedWordsCount(0);
    }
    
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem("theme");
        return savedTheme ? savedTheme : "light";
    });

    useEffect(() => {
        if (theme === "dark") {
            document.body.classList.add("dark-mode");
            document.documentElement.classList.add("dark-mode");
            localStorage.setItem("theme", "dark");
        } else {
            document.body.classList.remove("dark-mode");
            document.documentElement.classList.remove("dark-mode");
            localStorage.setItem("theme", "light");
        }
    }, [theme]);
    
    const switchTheme = () => {
        setTheme(theme === "light" ? "dark" : "light")
    }

    // ========== توابع بستن منو در موبایل ==========
    const closeNavbar = () => {
        const navbarCollapse = document.getElementById('navbarTogglerDemo01');
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
            try {
                const bsCollapse = window.bootstrap.Collapse.getInstance(navbarCollapse);
                if (bsCollapse) {
                    bsCollapse.hide();
                } else {
                    new window.bootstrap.Collapse(navbarCollapse, {
                        toggle: false
                    }).hide();
                }
            } catch (e) {
                navbarCollapse.classList.remove('show');
            }
            
            const toggler = document.querySelector('.navbar-toggler');
            if (toggler) {
                toggler.setAttribute('aria-expanded', 'false');
            }
        }
    };

    // ========== بستن منو هنگام تغییر مسیر صفحه (تغییر 3) ==========
    useEffect(() => {
        closeNavbar();
    }, [location.pathname]);

    // اضافه کردن event listener به همه لینک‌های داخل منو در موبایل
    useEffect(() => {
        const handleLinkClick = (e) => {
            if (window.innerWidth < 992) {
                setTimeout(() => {
                    closeNavbar();
                }, 150);
            }
        };
        
        const navbarCollapse = document.getElementById('navbarTogglerDemo01');
        if (navbarCollapse) {
            const links = navbarCollapse.querySelectorAll('a.nav-link, .dropdown-item, .dropdown-toggle');
            links.forEach(link => {
                link.addEventListener('click', handleLinkClick);
            });
            
            return () => {
                links.forEach(link => {
                    link.removeEventListener('click', handleLinkClick);
                });
            };
        }
    }, [isLoggedIn, regUser, location.pathname]); // location.pathname را به وابستگی‌ها اضافه کردم

    // بستن منو هنگام تغییر سایز صفحه از موبایل به دسکتاپ
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                const navbarCollapse = document.getElementById('navbarTogglerDemo01');
                if (navbarCollapse && navbarCollapse.classList.contains('show')) {
                    try {
                        const bsCollapse = window.bootstrap.Collapse.getInstance(navbarCollapse);
                        if (bsCollapse) {
                            bsCollapse.hide();
                        } else {
                            navbarCollapse.classList.remove('show');
                        }
                    } catch (e) {
                        navbarCollapse.classList.remove('show');
                    }
                    
                    const toggler = document.querySelector('.navbar-toggler');
                    if (toggler) {
                        toggler.setAttribute('aria-expanded', 'false');
                    }
                }
            }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const renderSubscriptionStatus = () => {
        if (!isLoggedIn) return null;
        
        const hasSubscription = subscriptionInfo?.isActive;
        
        if (hasSubscription && remainingDays > 0) {
            let daysText = '';
            if (remainingDays === 0) daysText = 'امروز منقضی می‌شود';
            else if (remainingDays === 1) daysText = '۱ روز';
            else daysText = `${remainingDays} روز`;
            
            return (
                <div className="subscription-status active">
                    <span className="subscription-icon">✅</span>
                    <span className="subscription-text">اشتراک فعال ({daysText} مانده)</span>
                </div>
            );
        } else {
            return (
                <div className="subscription-status inactive">
                    <span className="subscription-icon">⚠️</span>
                    <span className="subscription-text">
                        بدون اشتراک 
                    </span>
                    <Link to="/subscription" className="subscription-link">خرید اشتراک</Link>
                </div>
            );
        }
    };
    
    return (
        <div>
            <nav className={`navbar fixed-top navbar-expand-lg bg-body-tertiary ${theme === "dark" ? "navbar-dark" : "light "}`}>
                <div className="container">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <Link className="navbar-brand p-0 m-0 d-flex align-items-center" to="/">
                        <img src={Logo} alt="Logo" height="35" className="d-inline-block align-text-top" />
                        <span className="brand-name">چکیده‌سرا</span>
                    </Link>
                    <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link active" aria-current="page" to="/">صفحه اصلی</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <Link className="nav-link active dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                     خلاصه کتاب ها
                                </Link>
                                <ul className="dropdown-menu">
                                    <li><Link className="dropdown-item" to="/summary-books">🇬🇧 English Summaries</Link></li>
                                </ul>
                            </li>
                            {/* <Link as={Link} to="/podcast">
                                🎙️ پادکست
                            </Nav.Link> */}
                            <li className="nav-item">
                                <Link className="nav-link active" to="/podcast">پادکست</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/subscription">خرید اشتراک</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/blog">مقالات</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/about">درباره ما</Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className="nav-link active" to="/contact">تماس با ما</Link>
                            </li> */}
                            {isLoggedIn && (
                                <li className="nav-item dropdown">
                                    <Link className="nav-link active dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        👤 پنل شخصی
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li><Link className="dropdown-item" to="/flashcards">📇 فلش‌کارت‌ها</Link></li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li><Link className="dropdown-item" to="/studying-books">📖 کتاب‌های در حال مطالعه</Link></li>
                                        <li><Link className="dropdown-item" to="/completed-books">✅ کتاب‌های مطالعه شده</Link></li>
                                    </ul>
                                </li>
                            )}
                            {regUser && regUser.role === 'admin' && (
                                <li className="nav-item dropdown">
                                    <Link className="nav-link active dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        ⚙️ Admin Controllers
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li><Link className="dropdown-item" to="/add-summary-book">➕ Add Summary Book</Link></li>
                                        <li><Link className="dropdown-item" to="/add-persian-book">➕ Add Persian Book</Link></li>
                                        <li><Link className="dropdown-item" to="/admin-messages">📬 پیام‌های تماس</Link></li>
                                    </ul>
                                </li>
                            )}
                        </ul>
                        
                        {/* نمایش وضعیت اشتراک */}
                        {renderSubscriptionStatus()}
                        
                        {isLoggedIn ? (
                            <button className='btn btn-danger me-2' type="button" onClick={handleLogout}>خروج</button>
                        ) : (
                            <button className='btn btn-warning me-2' type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">ورود/ثبت نام</button>
                        )}
                    </div>
                    <label id="theme-toggle-button">
                        <input onClick={switchTheme} type="checkbox" id="toggle" />
                        <svg viewBox="0 0 65 40" xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                            <g transform="translate(3.5 3.5)" data-name="Component 15 – 1" id="Component_15_1">
                                <g filter="url(#container)" transform="matrix(1, 0, 0, 1, -3.5, -3.5)">
                                    <rect fill="#83cbd8" transform="translate(3.5 3.5)" rx="17.5" height="35" width="60.667" data-name="container" id="container"></rect>
                                </g>
                                <g transform="translate(2.333 2.333)" id="button">
                                    <g data-name="sun" id="sun">
                                        <g filter="url(#sun-outer)" transform="matrix(1, 0, 0, 1, -5.83, -5.83)">
                                            <circle fill="#f8e664" transform="translate(5.83 5.83)" r="15.167" cy="15.167" cx="15.167" data-name="sun-outer" id="sun-outer-2"></circle>
                                        </g>
                                        <g filter="url(#sun)" transform="matrix(1, 0, 0, 1, -5.83, -5.83)">
                                            <path fill="rgba(246,254,247,0.29)" transform="translate(9.33 9.33)" d="M11.667,0A11.667,11.667,0,1,1,0,11.667,11.667,11.667,0,0,1,11.667,0Z" data-name="sun" id="sun-3"></path>
                                        </g>
                                        <circle fill="#fcf4b9" transform="translate(8.167 8.167)" r="7" cy="7" cx="7" id="sun-inner"></circle>
                                    </g>
                                    <g data-name="moon" id="moon">
                                        <g filter="url(#moon)" transform="matrix(1, 0, 0, 1, -31.5, -5.83)">
                                            <circle fill="#cce6ee" transform="translate(31.5 5.83)" r="15.167" cy="15.167" cx="15.167" data-name="moon" id="moon-3"></circle>
                                        </g>
                                        <g fill="#a6cad0" transform="translate(-24.415 -1.009)" id="patches">
                                            <circle transform="translate(43.009 4.496)" r="2" cy="2" cx="2"></circle>
                                            <circle transform="translate(39.366 17.952)" r="2" cy="2" cx="2" data-name="patch"></circle>
                                            <circle transform="translate(33.016 8.044)" r="1" cy="1" cx="1" data-name="patch"></circle>
                                            <circle transform="translate(51.081 18.888)" r="1" cy="1" cx="1" data-name="patch"></circle>
                                            <circle transform="translate(33.016 22.503)" r="1" cy="1" cx="1" data-name="patch"></circle>
                                            <circle transform="translate(50.081 10.53)" r="1.5" cy="1.5" cx="1.5" data-name="patch"></circle>
                                        </g>
                                    </g>
                                </g>
                                <g filter="url(#cloud)" transform="matrix(1, 0, 0, 1, -3.5, -3.5)">
                                    <path fill="#fff" transform="translate(-3466.47 -160.94)" d="M3512.81,173.815a4.463,4.463,0,0,1,2.243.62.95.95,0,0,1,.72-1.281,4.852,4.852,0,0,1,2.623.519c.034.02-.5-1.968.281-2.716a2.117,2.117,0,0,1,2.829-.274,1.821,1.821,0,0,1,.854,1.858c.063.037,2.594-.049,3.285,1.273s-.865,2.544-.807,2.626a12.192,12.192,0,0,1,2.278.892c.553.448,1.106,1.992-1.62,2.927a7.742,7.742,0,0,1-3.762-.3c-1.28-.49-1.181-2.65-1.137-2.624s-1.417,2.2-2.623,2.2a4.172,4.172,0,0,1-2.394-1.206,3.825,3.825,0,0,1-2.771.774c-3.429-.46-2.333-3.267-2.2-3.55A3.721,3.721,0,0,1,3512.81,173.815Z" data-name="cloud" id="cloud"></path>
                                </g>
                                <g fill="#def8ff" transform="translate(3.585 1.325)" id="stars">
                                    <path transform="matrix(-1, 0.017, -0.017, -1, 24.231, 3.055)" d="M.774,0,.566.559,0,.539.458.933.25,1.492l.485-.361.458.394L1.024.953,1.509.592.943.572Z"></path>
                                    <path transform="matrix(-0.777, 0.629, -0.629, -0.777, 23.185, 12.358)" d="M1.341.529.836.472.736,0,.505.46,0,.4.4.729l-.231.46L.605.932l.4.326L.9.786Z" data-name="star"></path>
                                    <path transform="matrix(0.438, 0.899, -0.899, 0.438, 23.177, 29.735)" d="M.015,1.065.475.9l.285.365L.766.772l.46-.164L.745.494.751,0,.481.407,0,.293.285.658Z" data-name="star"></path>
                                    <path transform="translate(12.677 0.388) rotate(104)" d="M1.161,1.6,1.059,1,1.574.722.962.607.86,0,.613.572,0,.457.446.881.2,1.454l.516-.274Z" data-name="star"></path>
                                    <path transform="matrix(-0.07, 0.998, -0.998, -0.07, 11.066, 15.457)" d="M.873,1.648l.114-.62L1.579.945,1.03.62,1.144,0,.706.464.157.139.438.7,0,1.167l.592-.083Z" data-name="star"></path>
                                    <path transform="translate(8.326 28.061) rotate(11)" d="M.593,0,.638.724,0,.982l.7.211.045.724.36-.64.7.211L1.342.935,1.7.294,1.063.552Z" data-name="star"></path>
                                    <path transform="translate(5.012 5.962) rotate(172)" d="M.816,0,.5.455,0,.311.323.767l-.312.455.516-.215.323.456L.827.911,1.343.7.839.552Z" data-name="star"></path>
                                    <path transform="translate(2.218 14.616) rotate(169)" d="M1.261,0,.774.571.114.3.487.967,0,1.538.728,1.32l.372.662.047-.749.728-.218L1.215.749Z" data-name="star"></path>
                                </g>
                            </g>
                        </svg>
                    </label>
                </div>
            </nav>
            <Login />
        </div>
    )
}

export default Navbar